var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import classnames from "classnames";
import { ContextualMenu, ContextualMenuClient } from "./ContextualMenu";
import { Input } from "./Input";

// import { ZebulonTable } from "../table/ZebulonTable";
// import { buildMeta } from "./meta.dataset";
// ------------------------------------
// tests data
// ------------------------------------
// class Queries extends ScrollableGrid {}
var resizeHandleSize = 5;
var titleHeight = 20;

// -----------------------------------------
// component Layout
// ---------------------------------------
export var Layout = function (_Component) {
  _inherits(Layout, _Component);

  function Layout(props) {
    _classCallCheck(this, Layout);

    var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props));

    _initialiseProps.call(_this);

    var components = props.components.reduce(function (acc, component) {
      acc[component.id] = component;
      return acc;
    }, {});
    _this.state = {
      layout: props.layout,
      components: components,
      selectedTabs: {},
      activeLayout: "0",
      resizeImage: {
        position: "fixed",
        top: 0,
        height: 0,
        with: 0,
        backgroundColor: "blue"
      },
      dragPreviewStyle: { display: "none" }
    };
    // this.state.layoutDiv = this.buildLayout(props.layout, null, 0, components);
    return _this;
  }

  _createClass(Layout, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // if (this.props.keyEvent !== nextProps.keyEvent) {
      //   if (nextProps.keyEvent.which === 27 && this.contextualMenu) {
      //     this.contextualMenu.close();
      //   }
      //   const zoom = utils.isZoom(nextProps.keyEvent);
      //   if (zoom) {
      //     const lay = this.getLayout(this.getIds(": " + this.state.activeLayout));
      //     lay.zoom = (lay.zoom || 1) * (zoom === 1 ? 1.1 : 1 / 1.1);
      //     this.setState({ layout: this.state.layout });
      //     nextProps.keyEvent.preventDefault();
      //     return;
      //   }
      //   if (
      //     utils.isNavigationKey(nextProps.keyEvent) ||
      //     nextProps.keyEvent.type === "copy" ||
      //     nextProps.keyEvent.type === "paste"
      //   ) {
      //     this.setState({ keyEvent: nextProps.keyEvent });
      //     return;
      //   }
      //   this.keyEvent = true;
      // }
      if (this.props.sizes.height !== nextProps.sizes.height || this.props.sizes.width !== this.state.layout) {
        var layout = this.state.layout;
        layout.height = nextProps.sizes.height;
        layout.width = nextProps.sizes.width;
        this.setState({ layout: layout });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.keyEvent) {
        this.keyEvent = false;
        return false;
      }
      return true;
    }
    //----------------------------------------
    //utils
    //----------------------------------------

    // --------------------------------------
    // build layout
    // --------------------------------------

    //----------------------------------------
    // contextual menu
    //----------------------------------------

    // ---------------------------------------------

    //----------------------------------------
    // drag and drop
    //----------------------------------------

    //----------------------------------------
    // render
    //----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // let resizePreview;
      // if (this.state.dragId) {
      //   const y = this.rect.y - this.dragRect.y,
      //     x =
      //       this.rect.x -
      //       this.dragRect.x +
      //       this.layout.width -
      //       4 +
      //       (this.pageX2 || this.pageX) -
      //       this.pageX;
      //   console.log(
      //     "render layout",
      //     x,
      //     y,
      //     this.rect.x,
      //     this.dragRect.x,
      //     this.layout.width,
      //     this.pageX2,
      //     this.pageX
      //   );
      //   const previewStyle = {
      //     position: "absolute",
      //     height: this.rect.height,
      //     width: 4,
      //     transform: `translate(${x}px,${y}px)`,
      //     backgroundColor: "blue"
      //   };
      //   resizePreview = (
      //     <div style={previewStyle} ref={ref => (this.div = ref)} />
      //   );
      // } else {
      //   resizePreview = (
      //     <div style={{ display: "none" }} ref={ref => (this.div = ref)} />
      //   );
      // }
      if (this.props.visible === false) {
        return null;
      }
      var menu = this.state.layout.updatable ? React.createElement(ContextualMenu, {
        key: "layout-menu",
        getMenu: this.getMenu,
        component: "layout",
        ref: function ref(_ref) {
          return _this2.contextualMenu = _ref;
        }
      }) : null;
      return (
        // <div ref={ref => (this.dragLayer = ref)}>
        React.createElement(
          "div",
          {
            style: { position: "relative" },
            onDragStart: this.handleDragStart,
            onDragOver: this.handleDragOver
            // onDragExit={e => console.log("exit", e)}
            // onDragLeave={e => console.log("leave", e)}
            , onDrop: this.handleDrop,
            onClick: function onClick(e) {
              if (!e.defaultPrevented && !e.target.id.startsWith("menuRename") && _this2.contextualMenu) {
                _this2.contextualMenu.close();
              }
            },
            id: "layout",
            ref: function ref(_ref2) {
              return _this2.dragLayer = _ref2;
            }
          },
          this.computeLayout(this.state.layout, this.state.activeLayout),
          menu
        )
        // (  <div
        //     id="layout-preview"
        //     style={{ display: "none" }}
        //     ref={ref => (this.preview = ref)}
        //   />
        // </div>)

      );
      // {resizePreview}
    }
  }]);

  return Layout;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleKeyEvent = function (e) {
    var layout = _this3.getLayout(_this3.getIds(": " + _this3.state.activeLayout));
    if (layout && layout.handleKeyEvent) {
      return layout.handleKeyEvent(e);
    }
  };

  this.getParent = function (element, id) {
    if (element.id.startsWith(id)) {
      return element;
    } else if (element.parentElement) {
      return _this3.getParent(element.parentElement, id);
    } else {
      return null;
    }
  };

  this.getIds = function (id) {
    return id.slice(id.indexOf(":") + 2).split(" - ").map(function (id) {
      return Number(id);
    });
  };

  this.getLayout = function (ids) {
    var layout = _this3.state.layout,
        index = void 0;
    if (ids.length > 1) {
      ids.reverse();
      ids.pop(); // root
      while ((index = ids.pop()) !== undefined) {
        layout = layout.layouts[index];
      }
    }
    return layout;
  };

  this.isVisible = function (layoutId, index) {
    return (_this3.state.selectedTabs[layoutId] || 0) === index;
  };

  this.buildLayout = function (layout, parent, index, components) {
    var height = layout.height,
        width = layout.width,
        display = layout.display,
        layouts = layout.layouts,
        content = layout.content,
        visible = layout.visible;

    layout.id = parent ? parent.id + " - " + index : String(index);
    layout.parent = parent || {};
    layout.layouts = layout.layouts || [];
    layout.index = index;
    layout.calculatedZoom = (parent ? parent.calculatedZoom : 1) * (layout.zoom || 1);
    var resizeH = parent && parent.display === "block" && index < parent.layouts.length - 1 ? React.createElement("div", {
      id: "layout-resize-handle-H: " + layout.id,
      style: {
        width: width - resizeHandleSize,
        height: resizeHandleSize,
        cursor: "row-resize"
      },
      className: "zebulon-layout-resize-handle",
      draggable: true
    }) : null;
    var resizeV = parent && parent.display === "flex" && index < parent.layouts.length - 1 ? React.createElement("div", {
      id: "layout-resize-handle-V: " + layout.id,
      style: {
        height: height,
        width: resizeHandleSize,
        cursor: "col-resize"
      },
      className: "zebulon-layout-resize-handle",
      draggable: true
    }) : null;
    var getChildren = function getChildren(layouts, height, width) {
      if (layouts.length) {
        var childrenSize = 0;
        layouts.forEach(function (layout, index) {
          return childrenSize += display === "flex" ? layout.width : layout.height;
        });
        var ratio = display === "flex" ? width / childrenSize : // : (height - titleHeight * layouts.length) / childrenSize;
        height / childrenSize;
        layouts.forEach(function (lay, index) {
          lay.calculatedZoom = (lay.parent ? lay.parent.calculatedZoom : 1) * (lay.zoom || 1);
          if (display === "tabs") {
            lay.height = height;
            lay.width = width;
            lay.visible = _this3.isVisible(layout.id, index);
          } else if (display === "flex") {
            lay.height = height;
            lay.width *= ratio;
          } else {
            lay.width = width;
            lay.height *= ratio;
          }
        });
        return layouts.map(function (child, index) {
          return _this3.buildLayout(child, layout, index, components);
        });
      }
    };
    if (content && typeof components[content].title === "function") {
      var title = components[content].title(height, width, layout.calculatedZoom);
      layout.title = title.title;
      layout.titleHeight = title.height;
    } else if (content) {
      layout.title = components[content].title;
    }
    var heightBody = height - (layout.titleHeight || titleHeight) - resizeHandleSize * (resizeH === null ? 0 : 1),
        widthBody = width - resizeHandleSize * (resizeV === null ? 0 : 1);
    var style = {
      display: "block",
      height: height,
      width: width
    };
    var getHeader = function getHeader(layouts, isTab, parentId) {
      return layouts.map(function (layout, index) {
        var id = isTab ? parentId + " - " + String(index) : layout.id;
        return React.createElement(
          ContextualMenuClient,
          {
            id: "layout-title: " + id,
            key: index,
            menu: "layout-menu",
            component: "layout",
            className: classnames({
              "zebulon-layout-header ": !isTab,
              "zebulon-layout-header-active ": !isTab && _this3.state.activeLayout === id,
              "zebulon-layout-tab": isTab,
              "zebulon-layout-tab-selected": isTab && layout.visible,
              "zebulon-layout-tab-selected-active": isTab && layout.visible && _this3.state.activeLayout === id
            }),
            draggable: _this3.state.layout.updatable,
            style: {
              textAlign: "center",
              width: widthBody / layouts.length,
              height: layout.titleHeight || titleHeight,
              userSelect: "none"
            },
            onClick: isTab ? function (e) {
              e.stopPropagation();
              // e.preventDefault();
              if (_this3.state.selectedTabs[layout.parent.id] !== index || _this3.state.activeLayout !== id) {
                _this3.setState({
                  selectedTabs: Object.assign({}, _this3.state.selectedTabs, _defineProperty({}, layout.parent.id, index)),
                  activeLayout: id
                });
              }
            } : function (e) {
              e.stopPropagation();
              // e.preventDefault();
              if (_this3.state.activeLayout !== id) {
                _this3.setState({
                  activeLayout: id
                });
              }
            }
          },
          layout.title
        );
      });
    };
    var header = void 0;
    if (layout.parent.display === "tabs" && !visible) {
      return null;
    } else if (layout.parent.display === "tabs") {
      header = React.createElement(
        "div",
        {
          id: "layout-titles: " + layout.parent.id,
          style: { display: "-webkit-box" }
        },
        getHeader(layout.parent.layouts, true, layout.parent.id)
      );
    } else {
      header = getHeader([layout], false);
    }
    var body = content && typeof components[content].component === "function" ? React.createElement(
      "div",
      {
        id: "layout-component: " + layout.id,
        style: { position: "relative" }
      },
      components[content].component(heightBody, widthBody, layout.calculatedZoom, Object.assign({}, _this3.props, {
        keyEvent: _this3.state.keyEvent,
        isActive: _this3.state.activeLayout === layout.id
      }))
    ) : getChildren(layouts, heightBody, widthBody);
    if (!content && layouts.length === 0) {
      body = React.createElement(ContextualMenuClient, {
        id: "layout-body: " + layout.id,
        key: index,
        menu: "layout-menu",
        component: "layout",
        style: { width: widthBody, height: heightBody }
      });
    }

    return React.createElement(
      "div",
      {
        id: "layout: " + layout.id,
        key: index,
        className: classnames({
          "zebulon-layout": true
          // "zebulon-layout-component": layout.id === "0"
        }),
        style: Object.assign({}, style, {
          display: "-webkit-box"
        })
      },
      React.createElement(
        "div",
        {
          style: {
            display: "block",
            width: widthBody,
            height: height - resizeHandleSize * (resizeH === null ? 0 : 1)
          }
        },
        header,
        React.createElement(
          "div",
          {
            id: "layout-body: " + layout.id,
            className: classnames({
              "zebulon-layout-body ": true
              // ,
              // "zebulon-layout-body-active ":
              //   this.state.activeLayout === layout.id
            }),
            style: {
              fontSize: (content ? layout.calculatedZoom : 1) * 100 + "%",
              display: display === "flex" ? "-webkit-box" : display,
              width: widthBody,
              height: heightBody
            },
            onClick: function onClick(e) {
              e.stopPropagation();
              if (_this3.state.activeLayout !== layout.id) {
                _this3.setState({ activeLayout: layout.id });
              }
            }
          },
          body
        ),
        resizeH
      ),
      resizeV
    );
  };

  this.remove = function (layout) {
    return layout.parent.layouts = layout.parent.layouts.slice(0, layout.index).concat(layout.parent.layouts.slice(layout.index + 1));
  };

  this.splitHorizontaly = function (layout) {
    layout.layouts = [{
      height: 100,
      width: 100,
      display: layout.display,
      resizable: true,
      layouts: [],
      parent: layout,
      content: null,
      title: "???"
    }, {
      height: 100,
      width: 100,
      display: layout.display,
      resizable: true,
      layouts: layout.layouts,
      parent: layout,
      content: layout.content,
      title: "???"
    }];
    layout.content = null;
    layout.layouts[1].layouts.forEach(function (lay) {
      return lay.parent = layout.layouts[1];
    });
  };

  this.splitVerticaly = function (layout) {
    layout.layouts = [{
      height: 100,
      width: 100,
      display: layout.display,
      resizable: true,
      layouts: [],
      parent: layout,
      content: null,
      title: "???"
    }, {
      height: 100,
      width: 100,
      display: layout.display,
      resizable: true,
      layouts: layout.layouts,
      content: layout.content,
      parent: layout,
      title: "???"
    }];
    layout.content = null;
    layout.layouts[1].layouts.forEach(function (lay) {
      return lay.parent = layout.layouts[1];
    });
  };

  this.removeSplit = function (layout) {
    if (layout.layouts.length === 1) {
      layout.layouts[0].parent = layout.parent;
      layout.title = layout.layouts[0].title;
      layout.content = layout.layouts[0].content;
      layout.layouts = layout.layouts[0].layouts;
    } else {
      layout.parent.content = layout.content;
      layout.parent.layouts = layout.layouts;
      layout.parent.display = layout.display;
    }
  };

  this.insertLayout = function (parent, layout, index) {
    _this3.remove(layout);
    layout.parent = parent;
    parent.layouts = parent.layouts.slice(0, index).concat([layout]).concat(parent.layouts.slice(index));
  };

  this.handleClickMenu = function (data, item) {
    var ids = _this3.getIds(data.id);
    // const root = ids.length === 1;
    var layout = _this3.getLayout(ids);
    if (item.id === 0) {
      _this3.remove(layout);
    } else if (item.id === 1) {
      layout.content = null;
      layout.layouts = [];
    } else if (item.id === 2) {
      _this3.removeSplit(layout);
    } else if (item.id === 3) {
      _this3.splitVerticaly(layout);
      layout.display = "flex";
    } else if (item.id === 4) {
      _this3.splitHorizontaly(layout);
      layout.display = "block";
    } else if (item.id === 5) {
      layout.display = layout.display === "flex" ? "block" : "-webkit-box";
    } else if (item.id >= 100) {
      layout.content = item.component;
    }
    _this3.setState({ layout: _this3.state.layout });
    // console.log("clickmenu", data, item, layout);
  };

  this.getMenu = function (menu, data) {
    var ids = _this3.getIds(data.id);
    // const root = ids.length === 1;
    var layout = _this3.getLayout(ids);
    var menus = [];
    var menuComponents = Object.keys(_this3.state.components).map(function (key, index) {
      return {
        id: 100 + index,
        type: "menu-item",
        separation: false,
        caption: "" + _this3.state.components[key].caption,
        component: _this3.state.components[key].id,
        onClick: _this3.handleClickMenu
      };
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      disable: layout.id === "0" || !layout.content && layout.layouts.length === 0 && !data.id.startsWith("layout-title"),
      separation: false,
      caption: "Remove",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: false,
      disable: layout.content === null && layout.layouts.length === 0,
      caption: "Remove content",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: false,
      disable: !layout.parent || layout.layouts.length > 1 && layout.parent.layouts > 1 || layout.content || !layout.content && layout.layouts.length === 0,
      caption: "Remove split",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: menus.length > 0,
      caption: "Split verticaly",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: false,
      caption: "Split horizontaly",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: false,
      caption: "Transpose",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "sub-menu",
      separation: menus.length > 0,
      disable: !layout.content && layout.layouts.length === 0,
      caption: "Rename",
      children: [{
        id: 100,
        type: "jsx",
        navigation: false,
        // caption: "Filter",
        content: React.createElement(Input, {
          key: 100,
          id: "menuRename",
          hasFocus: true,
          dataType: "string",
          value: layout.title,
          editable: true,
          style: { textAlign: "left" },
          onChange: function onChange(e) {
            layout.title = e;
            _this3.setState({ layout: _this3.state.layout });
          }
        })
      }]
    });
    menus.push({
      id: menus.length,
      type: "sub-menu",
      separation: menus.length > 0,
      disable: !(layout.content === null && layout.layouts.length === 0),
      caption: "Add component",
      children: menuComponents
    });
    if (menus.length) {
      return {
        type: "menu",
        position: "bottom",
        children: menus
      };
    } else {
      return null;
    }
  };

  this.handleDragStart = function (e, type) {
    if (_this3.contextualMenu) {
      _this3.contextualMenu.close();
    }
    // this.dragMessage = { type, index: e.target.id, x: e.pageX };
    _this3.pageX = e.pageX;
    _this3.pageY = e.pageY;
    // this.pageXStart = e.pageX;
    // this.pageYStart = e.pageY;
    e.dataTransfer.setData("text", e.target.id);
    _this3.dragId = e.target.id;
    if (e.target.id.startsWith("layout-resize-handle")) {
      var ids = _this3.getIds(e.target.id);
      var layout = _this3.getLayout(ids);
      _this3.layout = layout;
      var length = "layout-resize-handle".length;
      _this3.dragDirection = e.target.id.slice(length, length + 2) === "-V" ? "vertical" : "horizontal";
      // const rect = document
      //   .getElementById("layout: " + e.target.id.slice(length + 4))
      //   .getBoundingClientRect();
      // const dragRect = this.dragLayer.getBoundingClientRect();
      // const dragPreviewStyle = {
      //   position: "relative",
      //   backgroundColor: "red"
      // };
      // let x, y;
      // if (this.dragDirection === "vertical") {
      //   dragPreviewStyle.height = rect.height;
      //   dragPreviewStyle.width = 4;
      //   dragPreviewStyle.top = rect.top - dragRect.top;
      //   dragPreviewStyle.left = rect.left - dragRect.left + rect.width - 4;
      // } else {
      //   dragPreviewStyle.height = 4;
      //   dragPreviewStyle.width = rect.width;
      //   dragPreviewStyle.top = rect.top - dragRect.top + rect.height - 4;
      //   dragPreviewStyle.left = rect.left - dragRect.left;
      // }
      // this.dragPreviewStyle = dragPreviewStyle;
      // e.dataTransfer.setDragImage(this.preview, 0, 0);
      // this.setState({ dragPreviewStyle });
    }
    // e.stopPropagation();
    // console.log(
    //   "dragstart",
    //   e.pageX,
    //   e.pageY,
    //   e.dataTransfer.getData("text"),
    //   e.target,
    //   e.clientOffset
    // );
  };

  this.handleDragOver = function (e) {
    if (_this3.dragId) {
      if (_this3.dragId.startsWith("layout-resize-handle") && _this3.state.layout.resizable) {
        e.preventDefault();
        // e.stopPropagation();
        var dragPreviewStyle = Object.assign({}, _this3.dragPreviewStyle);
        if (_this3.dragDirection === "vertical") {
          dragPreviewStyle.left += e.pageX - _this3.pageX;
        } else {
          dragPreviewStyle.top += e.pageY - _this3.pageY;
        }
      } else if (_this3.dragId.startsWith("layout-title") && _this3.state.layout.updatable && (!e.target.id.startsWith("layout-title") || _this3.getLayout(_this3.getIds(e.target.id)).parent.display === "tabs")) {
        // you cant drop a header on a child
        var component = _this3.getParent(e.target, "layout-component");
        if (_this3.getParent(component || e.target, _this3.dragId.replace("-title", "")) === null) {
          e.preventDefault();
        }
      }
    }
  };

  this.handleDrop = function (e) {
    // console.log("drop", id, e.pageX, e.pageY, e.target);
    if (_this3.dragId) {
      e.preventDefault();
      var id = e.dataTransfer.getData("text");
      if (id.startsWith("layout-resize-handle")) {
        var length = "layout-resize-handle".length;
        var ids = _this3.getIds(id); //id.slice(length + 4).split(" - ");
        var root = ids.length === 1;
        var lastIndex = Number(ids.pop());
        var direction = id.slice(length, length + 2) === "-V" ? "vertical" : "horizontal";
        var delta = 0;
        var layout = _this3.getLayout(ids);
        if (root) {
          if (direction === "horizontal") {
            delta = e.pageY - _this3.pageY;
            layout.height += delta;
          } else {
            delta = e.pageX - _this3.pageX;
            layout.width += delta;
          }
        } else {
          if (direction === "horizontal") {
            delta = e.pageY - _this3.pageY;
            layout.layouts[lastIndex].height += delta;
            layout.layouts[lastIndex + 1].height -= delta;
          } else {
            delta = e.pageX - _this3.pageX;
            layout.layouts[lastIndex].width += delta;
            layout.layouts[lastIndex + 1].width -= delta;
          }
        }
        _this3.setState({ layout: _this3.state.layout });
      } else if (id.startsWith("layout-title")) {
        var body = e.target.id.startsWith("layout-title") ? e.target : _this3.getParent(e.target, "layout-body");
        if (body !== null) {
          var dropIds = _this3.getIds(body.id);
          var dropIndex = dropIds[dropIds.length - 1];
          var dragIds = _this3.getIds(id);
          var dropLayout = _this3.getLayout(dropIds);
          var dragLayout = _this3.getLayout(dragIds);
          var rect = void 0;
          if (dropLayout.content === null && dropLayout.layouts.length === 0) {
            dropLayout.title = dragLayout.title;
            dropLayout.content = dragLayout.content;
            dropLayout.layouts = dragLayout.layouts;
            _this3.remove(dragLayout);
          } else {
            // const element = document.getElementById(body);
            rect = body.getBoundingClientRect();
            var top = e.clientY - rect.top < rect.height / 2;
            var left = e.clientX - rect.left < rect.width / 2;

            if (dropLayout.content !== null || dropLayout.parent.display === "tabs") {
              if (dropLayout.parent.display === "block" || dropLayout.parent.display === "tabs") {
                _this3.insertLayout(dropLayout.parent, dragLayout, dropIndex + !top);
              } else if (dropLayout.parent.display === "flex") {
                _this3.insertLayout(dropLayout.parent, dragLayout, dropIndex + !left);
              }
            }
          }
          _this3.setState({ layout: _this3.state.layout });
          // console.log(
          //   "dropbody",
          //   body,
          //   e.pageX,
          //   e.pageY,
          //   rect,
          //   dragIds,
          //   dropIds,
          //   e.target
          // );
        }
      }
      _this3.dragId = null;
    }
  };

  this.computeLayout = function (layout, active) {
    return _this3.buildLayout(layout, null, 0, _this3.state.components);
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-controls/lib/Layout.js
// module id = 302
// module chunks = 0